import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api/useApi';

export function usePluginCatalogue() {
  const api = useApi();
  return useQuery({
    queryKey: ['plugins'],
    queryFn: () => api.plugins.list(),
    refetchOnWindowFocus: 'always',
    refetchInterval: 15000,
    retry: false,
  });
}
